import React, { forwardRef, useEffect, useRef } from 'react';

interface IndeterminateCheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
    indeterminate?: boolean;
}

// Checkbox that supports the half-checked (indeterminate) state, which is only
// settable via the DOM property, not an HTML attribute. Compatible with
// react-table's getToggleRowSelectedProps()/select-all header usage.
const IndeterminateCheckbox = forwardRef<HTMLInputElement, IndeterminateCheckboxProps>(
    ({ indeterminate = false, ...rest }, ref) => {
        const defaultRef = useRef<HTMLInputElement>(null);
        const resolvedRef = (ref as React.RefObject<HTMLInputElement>) || defaultRef;

        useEffect(() => {
            if (resolvedRef.current) {
                resolvedRef.current.indeterminate = indeterminate;
            }
        }, [resolvedRef, indeterminate]);

        return <input type="checkbox" className="form-check-input" ref={resolvedRef} {...rest} />;
    }
);

export default IndeterminateCheckbox;
